/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { EInvoicingSettings } from './';
import {
    EInvoicingSettingsFromJSON,
    EInvoicingSettingsFromJSONTyped,
    EInvoicingSettingsToJSON,
} from './';
import type { InvoicingSettings } from './';
import {
    InvoicingSettingsFromJSON,
    InvoicingSettingsFromJSONTyped,
    InvoicingSettingsToJSON,
} from './';
import type { PaymentSettings } from './';
import {
    PaymentSettingsFromJSON,
    PaymentSettingsFromJSONTyped,
    PaymentSettingsToJSON,
} from './';
import type { QuoteSettings } from './';
import {
    QuoteSettingsFromJSON,
    QuoteSettingsFromJSONTyped,
    QuoteSettingsToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalEntityPreferencesResource
 */
export interface LegalEntityPreferencesResource {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityPreferencesResource
     */
    legalEntityId: string;
    /**
     * 
     * @type {PaymentSettings}
     * @memberof LegalEntityPreferencesResource
     */
    paymentSettings: PaymentSettings;
    /**
     * 
     * @type {InvoicingSettings}
     * @memberof LegalEntityPreferencesResource
     */
    invoicingSettings: InvoicingSettings;
    /**
     * 
     * @type {QuoteSettings}
     * @memberof LegalEntityPreferencesResource
     */
    quoteSettings: QuoteSettings;
    /**
     * 
     * @type {EInvoicingSettings}
     * @memberof LegalEntityPreferencesResource
     */
    eInvoicingSettings: EInvoicingSettings;
}

/**
 * Check if a given object implements the LegalEntityPreferencesResource interface.
 */
export function instanceOfLegalEntityPreferencesResource(value: object): value is LegalEntityPreferencesResource {
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('paymentSettings' in value) || value['paymentSettings'] === undefined) return false;
    if (!('invoicingSettings' in value) || value['invoicingSettings'] === undefined) return false;
    if (!('quoteSettings' in value) || value['quoteSettings'] === undefined) return false;
    if (!('eInvoicingSettings' in value) || value['eInvoicingSettings'] === undefined) return false;
    return true;
}

export function LegalEntityPreferencesResourceFromJSON(json: any): LegalEntityPreferencesResource {
    return LegalEntityPreferencesResourceFromJSONTyped(json, false);
}

export function LegalEntityPreferencesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityPreferencesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'],
        'paymentSettings': PaymentSettingsFromJSON(json['paymentSettings']),
        'invoicingSettings': InvoicingSettingsFromJSON(json['invoicingSettings']),
        'quoteSettings': QuoteSettingsFromJSON(json['quoteSettings']),
        'eInvoicingSettings': EInvoicingSettingsFromJSON(json['eInvoicingSettings']),
    };
}

export function LegalEntityPreferencesResourceToJSON(value?: LegalEntityPreferencesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntityId': value['legalEntityId'],
        'paymentSettings': PaymentSettingsToJSON(value['paymentSettings']),
        'invoicingSettings': InvoicingSettingsToJSON(value['invoicingSettings']),
        'quoteSettings': QuoteSettingsToJSON(value['quoteSettings']),
        'eInvoicingSettings': EInvoicingSettingsToJSON(value['eInvoicingSettings']),
    };
}

